<template>
  <div class="header" id="header">
    <div class="header-container" ref="header">
      <div class="header-icon"  v-if="!mobeilMenuShow">
        <img src="../assets/images/logo.png" alt="" class="logo">
        <div class="right-icon">
          <img
              class="header-user-img"
              src="../assets/images/user.png"
              @click="toLoginCom('登录',0)"
          />
          <span class="line">|</span>
          <img
              class="header-toggle-img"
              :src="navbarOpen ? collapseCloseImg : collapseImg"
              alt=""
              @click="changeNavbarOpen"
          />
        </div>
      </div>

      <div class="navbar-header">
        <!--  pc 正常情况下菜单   -->
       <div class="nav header-tabs" v-if="!pcMenuShow">
         <div class="logo menu">
           <img
               class="header-icon-img cs"
               src="../assets/images/logo.png"
           />
         </div>
         <div class="menu-list">
           <div class="tabs" v-for="(item, index) in menuList"
                :class="{ active: tabIndex == index }"
                @click="didClick_tab(item.type, index, item.name)"
           >
             <div class="label">
               {{ item.name }}
             </div>
           </div>
         </div>

<!--          登录注册页面-->
         <div class="login-register menu" v-if="!this.$tool.isLogin()">
          <span v-for="(item, index) in loginList"
                :class="{active : loginIndex == index}"
                @click="toLoginCom(item.name,index)"
          >
            {{ item.name }}
          </span>
         </div>
<!--       登录后 菜单我的作品 退出登录-->
         <div class="login-user menu" v-if="this.$tool.isLogin()" @mouseenter="userMenuShow" @mouseleave="userMenuHide" >
            <span>您好，{{ loginInfo.name? loginInfo.name : (loginInfo.mobile?.substring(loginInfo.mobile.length-4) || '')}}</span>
           <i :class="userMenuClass"></i>
           <div class="my-work-menu" v-if="userMenuIsShow">
              <li v-for="(item, index) in userMenu" @click.stop="toUserMenuCom(index)">{{item}}</li>
           </div>
         </div>

       </div>
      </div>
    </div>
    <!--  移动端 导航  登录 -->
    <el-drawer
            title=""
            :visible.sync="navbarOpen"
            direction="rtl"
            size="70%">
        <div class="menu-list-mobile">

            <div class="tabs" v-for="(item, index) in menuList"
                 :class="{ active: tabIndex == index }"
                 @click="didClick_tab(item.type, index, item.name)"
            >
                {{ item.name }}
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
    </el-drawer>
    <el-drawer
        title=""
        :visible.sync="mobileUserShow"
        direction="rtl"
        size="70%"
    >
      <div class="menu-list-mobile">
        <div class="user-title">您好，{{ loginInfo.name? loginInfo.name : (loginInfo.mobile?.substring(loginInfo.mobile.length-4) || '')}}</div>
        <div class="tabs" v-for="(item, index) in userMenu"
             :class="{ active: tabIndex == index }"
             @click="toUserMenuCom(index)"
        >
          {{ item }}
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import _ from "lodash";
import { mapMutations, mapState } from "vuex";
export default {
  name: 'Header',
  props: {
    msg: String,
    mobeilMenuShow: Boolean,
    pcMenuShow: Boolean,
  },
  data() {
    return{
      tabIndex: 0,
      navbarOpen: false,
      collapseImg: require("../assets/images/collapse.png"),
      collapseCloseImg: require("../assets/images/collapse-close.png"),
      menuList: [
        {type: 'matchHome', name: '首页',},
        {type: 'eventArrangement', name: '赛事安排',},
        {type: 'entryInformation', name: '参赛须知',},
        {type: 'winList', name: '中奖名单',},
        {type: 'allWorks', name: '全部作品',},
        {type: 'dellPrecision', name: 'DELL Precision 25周年',}
      ],
      drawer:true,
      loginList: [
        {class: 'login', name: '登录'},
        {class: 'register', name: '注册'},
      ],
      loginIndex: -1,
      rootName: '',
      userMenuIsShow: false,
      userMenuClass: 'el-icon-arrow-down',
      userMenu: ['我的作品', '退出登录'],
      mobileUserShow: false,
      loginInfo: {},
      isLoginShow: null
    }
  },
  computed: mapState(['loginStyle']),
  watch: {
    rootName(newVal, old) {
      document.documentElement.scrollTop=0
      if(newVal == 'opusReveal'){
        this.tabIndex = 4;
      }
        if(newVal == 'winnersList'){
            this.tabIndex = 3;
        }
    },
    loginStyle(newVal, oldVal) {
      console.log(newVal, oldVal)
      if(newVal == '登录'){
        this.loginIndex = 0
      }else{
        this.loginIndex = 1
      }
    },
  },
  mounted() {
    if(this.$route.name == 'login'){
      if(this.loginStyle == '登录'){
        this.loginIndex = 0
      }else{
        this.loginIndex = 1
      }
    }

    this.rootName = this.$route.name;
    this.getUserInfo();
      // 监听滚动事件
      window.addEventListener(
          "scroll",
          _.debounce(
              () => {
                this.onScroll();
                //如果是wap端 关闭长在打开的header
                if (this.$store.state.isMobile) {
                  this.navbarOpen = false;
                }
                //header 滚动 超过 100px header背景颜色 变深
                let scrollTop =
                    document.documentElement.scrollTop || document.body.scrollTop;
                this.headerDark = scrollTop > 100;
              },
              1,
              false
          ),
          true
      );
  },
  methods: {
    ...mapMutations(['changeloginStyle', 'changetoTabClick']),
    didClick_tab(type, idx, ch){
      if(type == 'allWorks'){
        this.tabIndex = idx;
        this.$router.push({path:'/opusReveal'});
      }else if(type == "winList"){
          this.tabIndex = idx;
          this.$router.push({path:'/winnersList'});
      }else{
        if(this.$route.name != 'home'){
          this.$router.push({path:'/'});
          this.changetoTabClick(type)
        }else{
          this.changetoTabClick('')
          this.tabIndex = idx;
          this.navbarOpen = false;
          if(type == "dellPrecision"){
            this.gioAction('precision25thart_topbtn25thClick');
            window.open('https://www.dellemc-solution.com/campaign/precision-25th');
          }

          // if(type == 'downloadMaterials'){
          //   this.downloadFile()
          // }
          //手机
          if (this.$store.state.isMobile) {
            this.openIndex = null;
            let targetbox = document.getElementById(type);
            if( targetbox ){
              this.ScrollTop(targetbox.offsetTop, 500, type);
            }

          } else {
            this.openIndex = null;
            if(type != 'matchHome'){
              let targetbox = document.getElementById(type);
              if(targetbox){
                this.ScrollTop(targetbox.offsetTop - 30, 500, type);
              }
            }else{
              this.ScrollTop(0, 500, type);
            }
          }
          this.$emit('getTabIndex',this.tabIndex)
        }
      }
    },
    ScrollTop(number, time, type) {
      document.body.scrollTop = document.documentElement.scrollTop = number;
    },
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(
          ".home-container .page-box"
      );
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop - 70);
      });

      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      // 定义当前点亮的导航下标
      let navIndex = -1;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是 n 了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      // 把下标赋值给 vue 的 data
      this.tabIndex = 0;
      if(this.$route.name == 'opusReveal'){
        this.tabIndex = 4;
      }
        if(this.$route.name == 'winnersList'){
            this.tabIndex = 3;
        }
    },
    changeMeuOpen(){
        this.navbarOpen = true;
    },
    changeNavbarOpen() {
      this.navbarOpen = true;
      this.mobileUserShow = false;
    },
    toLoginCom(name, index) {
      console.log('name',name)
      this.loginIndex = index;
      this.changeloginStyle(name)
      console.log(this.loginStyle)
      //未登录 跳转登录页  登录打开登录信息抽屉
      if(this.$tool.isLogin()){
        this.mobileUserShow = true;
        this.navbarOpen = false;
      }else{
        this.$router.push({path:'/login'});
      }
    },
    userMenuShow() {
      this.userMenuIsShow = true;
      this.userMenuClass = 'el-icon-arrow-up';
    },
    userMenuHide() {
      this.userMenuIsShow = false;
      this.userMenuClass = 'el-icon-arrow-down';
    },
    toUserMenuCom(index) {
      //我的作品 没有work_id 跳转到上传页面
      if(index == 0){
        //如果上传过 直接进入详情页面
        let userWorkId = this.$tool.getLS( 'userWorkId',1)
        if(userWorkId){
          if(this.rootName == 'opusInfo'){
            this.$tool.setLS('workId', userWorkId,1)
            this.$router.push({path:'/opusInfo', query: { id: userWorkId }});
            location. reload()
          }else{
            this.$router.push({path:'/opusInfo', query: { id: userWorkId }});
          }
        }else{
          //我的作品
          this.getMyWorkId()
        }
      }else{
        //退出登录
        this.$tool.logout()
        if(this.$route.name == 'uploadOpus'){
          this.$router.push({path:'/login'});
        }
        this.$tool.delLS('myWorkList') //清空我的上传信息
        this.$tool.delLS('workId') //清空workId
        this.$tool.delLS('userWorkId') //清空我的workId
        location. reload()
      }
    },
    //我的作品页  是否上传过作品
    getMyWorkId() {
      console.log('dd')
        this.$api.getMyWork(this.$tool.isLogin().session, this.$tool.isLogin().OCSESSID)
        .then(res=>{
            console.log('是否上传作品',res)
           //未上传作品
            if(res.data.length == 0){
              this.$alert('报名已截止',  {
                distinguishCancelAndClose: true,
                // cancelButtonText: '关闭'
              })
                .then(() => {
                  // this.$router.push({path:'/uploadOpus'});
                })
                .catch(action => {
                });
            }else {
              //改变workId
              this.$tool.setLS('workId', res.data.work_id,1)
              //登录这者 workId 用来判断审核状态的显隐
              this.$tool.setLS('userWorkId', res.data.work_id,1)
              console.log( '我的作品的id',this.$tool.getLS( 'workId',1))
              setTimeout(() => {
                this.$router.push({path:'/opusInfo', query: { id: res.data.work_id }});
              }, 300)
            }
          })
        .catch((e) => {
        });
    },
    //获取用户信息
    async getUserInfo() {
        if(this.$tool.isLogin()){
            this.isLoginShow = true;
            this.loginInfo = await this.$tool.getUserInfo();
        }
    }
  }
}
</script>

<style scoped lang="less">
//pc
@media (min-width: 992px){
  .header{
    position: relative;
    height: 100px;
    z-index: 2;
    .header-icon{
      display: none;
    }
    .navbar-header{
      width: 100%;
      height: 40px;
      padding-top: 60px;
      display: flex;
      justify-content: center;
      .nav{
        display: flex;
        justify-content: start;
        flex-wrap: nowrap;
        .menu{
          list-style: none;
          margin-right: 15px;
          &.logo{
            img{
              width: 152px;
              height: 38px;
              display: block;
            }
          }
          &.login-register{
            color: #fff;
            line-height: 38px;
            font-size: 17px;
          }
          &.login-user{
            display: revert;
            font-size: 17px;
            color: #fff;
            line-height: 38px;
            min-width: 114px;
            cursor: pointer;
            i{
              display: inline-block;
              width: 17px;
              height: 17px;
              background: rgba(255,255,255,.3);
              border-radius: 50%;
              font-size: 12px;
              vertical-align: text-top;
              text-align: center;
              line-height: 17px;
              font-weight: bold;
              margin-left: 4px;
            }
            .my-work-menu{
              position: absolute;
              width: 108px;
              height: 72px;
              border-radius: 4px;
              background: #e5f7ff;
              padding: 0 10px;
              box-sizing: border-box;
              li{
                width: 100%;
                line-height: 36px;
                font-size: 16px;
                color: #4b6797;
                text-align: center;
                cursor: pointer;
                &:first-child{
                  border-bottom: 1px solid #c5d7e7;
                }
              }
            }
          }
        }
        .menu-list{
          display: flex;
          justify-content: start;
          .tabs{
            width: 126px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            color: #4b6797;
            white-space: nowrap;
            background: url("../assets/images/nav.png") no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            margin-right: 10px;
            &:last-child{
              width: 200px;
            }
          }
          .tabs.active{
            color: #fff;
            background: url("../assets/images/nav_hover.png") no-repeat;
            background-size: 100% 100%;
            a{
              color:  #fff;
              text-decoration: none;
            }
          }
        }
        .login-register{
          display: flex;
          flex-wrap: nowrap;
          cursor: pointer;
          span{
            min-width: 40px;
            display: inline-block;
            &.active{
              color: #5b81df;
            }
            &:last-child{
              padding-left: 4px;
              position: relative;
              &:before{
                content: '';
                width: 1px;
                height: 20px;
                background: #fff;
                position: absolute;
                top: 9px;
                left: -2px;
              }
            }
          }
        }
      }
    }
  }

}
//
@media (max-width: 992px) {
  .header {
    //height: 100px;
    .header-container {
      position: relative;
      z-index: 2;
      width: 100%;
      height: 70px;
      justify-content: flex-end;
      display: flex;
      align-items: center;
      background: rgba(255,255,255,.3);
      .header-icon {
        width: 100%;
        //cursor: pointer;
        display: flex;
        justify-content: space-between;
        padding: 0 30px;
        .logo{
          width: 150px;
          height: 35px;
        }
        .right-icon{
          display: flex;
          align-items: center;
          .line{
            width: 2px;
            height: 30px;
            background: #fff;
            font-size: 0px;
            margin: 10px;
          }
          .header-user-img{
            width: 40px;
            height: auto;
            display: inline-block;
          }
          .header-toggle-img{
            width: 32px;
            height: auto;
            display: block;
          }
        }
      }


      .navbar-header {
        position: absolute;
        top: 110px;
        left: 145px;
        right: 155px;
        justify-content: flex-start;
        flex-direction: column;
        margin: 0 -160px 0 -147px;
        height: 0px;
        box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.05);
        background-color: rgba(243, 247, 255, 0.9);
        backdrop-filter: blur(20px);
        overflow: hidden;
        transition-timing-function: ease;
        transition-duration: 0.35s;
        transition-property: height, visibility;

        &.open {
          height: auto;
          padding-bottom: 50px;
        }

        &.open.sub-open {
          height: 920px;
        }
      }

      .header-tabs {
        width: 100%;
        flex-direction: column;
        font-size: 28px;

        & > li {
          margin: 0 36px;
          justify-content: flex-start;
          border-bottom: 1px solid #dddddd;
          display: block;
          .navbar-top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            img {
              position: relative;
              top: unset;
              margin-right: 12px;
            }
          }
          .label {
            height: 99px;
            line-height: 99px;
            display: inline-block;
          }

          .arrow {
            display: block;
            position: absolute;
            top: 45px;
            right: 0;
            width: 24px;
            height: 40px;
            object-fit: contain;
          }

          img {
            display: none;
          }


          &.open {
            .arrow {
              transform: rotate(180deg);
            }

          }
        }
      }

      .header-tabs + .header-tabs {
        border: none;
        margin: 0;
        padding: 0;
      }
    }

    .menu-list-mobile {
        padding: 0 60px 0 66px;
        .user-title{
          font-size: 29px;
          color: #4b6797;
          line-height: 116px;
        }
        .tabs {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 29px;
            color: #4b6797;
            height: 116px;
            line-height: 116px;
            border-bottom: 1px solid #d5dce7;
            cursor: pointer;

            i {
                text-align: right;
            }
        }
    }
  }

}

</style>
